<template>
  <div class="au">
    <TopHead name="关于我们" />
    <div class="mt_12">
      <div v-html="info.content" />
    </div>
  </div>
</template>

<script>
  export default {
    name: "AboutUs",
    data() {
      return {info:{}}
    },
    created(){
      this.getInfoContentList();
    },
    methods: {
      getInfoContentList(){
        this.$api.getInfoContentList({pageSize:1,pageIndex:1,data:{columnCode:'wzms'}}).then(res => {
          this.info = res.data.rows[0];
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .au{
    .mt_12{
      margin-top: 20px;
      padding: 0 20px 20px;
    }
    background-color: #f5f5f5;
    padding-top: 85px;
    height: 100vh;
    box-sizing: border-box;
    overflow: auto;
    ::v-deep img{
      max-width: 100%;
    }
    ::v-deep video{
      max-width: 100%;
      height:auto;
    }
  }

</style>
